import * as types from './actionsTypes.codeMetaData';


let initialStateObj = {
    isInit: false,
    codeString: '',
    context: [],
    relationships: [],
    error: null,
    visualMap: {},
    visualRelationships: [],
    visualList: [],
    declarationIndex: new Map(),
    projectVariablesList: [],
    projectVariableRelationships: [],
    highlights: [],
    syntaxErrors: [],
    strings: [],
    playStrings: new Set(),
    patternStrings: new Set(),
    brackets: {},
    alanBtnPopups: {},
    projectApis: {},
    corpuses: {},
    intents: {},
    transforms: {},
    parsedScriptsInfo: {
        scriptsCount: 0,
        parsedScriptsCount: 0,
    }
};

export default function codeMetaDataReducer(state = initialStateObj, action) {
    const {
        codeString,
        context,
        relationships,
        error,
        visualMap,
        visualList,
        visualRelationships,
        declarationIndex,
        type,
        projectVariablesList,
        projectVariableRelationships,
        brackets,
        bracketsInStrings,
        strings,
        playStrings,
        patternStrings,
        membersMap,
        syntaxErrors,
        invalidBrackets,
        scripts,
        alanBtnPopups,
        projectApis,
        corpuses,
        intents,
        transforms,
        hasUnsavedChanges,
        methodsMap,
        imports,
        parsedScriptsInfo
    } = action;

    switch (type) {
        case types.CODE_CHANGE:
            return {
                ...state,
                codeString,
            };
        case types.CODE_META_DATA_RESET:
            return {
                ...state,
                isInit: false,
            };
        case types.CHECK_ERRORS:
            return {
                ...state,
                scripts,
            };

        case types.SCRIPR_PARSED_OK:
            return {
                ...state,
                parsedScriptsInfo: parsedScriptsInfo,
            };

        case types.ERRORS_CHANGE:
            return {
                ...state,
                syntaxErrors,
                hasUnsavedChanges
            };

        case types.CODE_PARSING_REQ:
            return {
                ...state,
                isParsingInProcess: true,
            };

        case types.CODE_META_DATA_CHANGE:

            return {
                ...state,
                isParsingInProcess: false,
                context,
                relationships,
                error,
                visualMap,
                visualList,
                visualRelationships,
                declarationIndex,
                projectVariablesList,
                projectVariableRelationships,
                brackets,
                bracketsInStrings,
                strings,
                playStrings,
                patternStrings,
                membersMap,
                invalidBrackets,
                isInit: true,
                alanBtnPopups,
                projectApis,
                corpuses,
                intents,
                transforms,
                methodsMap,
                imports
            };
        default:
            return state;
    }
}
